import { render, staticRenderFns } from "./Amministrazione.vue?vue&type=template&id=63ce1684&scoped=true&"
import script from "./Amministrazione.vue?vue&type=script&lang=js&"
export * from "./Amministrazione.vue?vue&type=script&lang=js&"
import style0 from "./Amministrazione.vue?vue&type=style&index=0&id=63ce1684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ce1684",
  null
  
)

export default component.exports